/* eslint-disable camelcase */
/**
 *  Do not edit this file! It is autogenerated from the harmony composerasdfsad
 */
import {
  withLayout,
  withLayoutAccordion,
  
} from '@thd-olt-component-react/fusion-utils';


  import {
    SuperSkuMiddleware as SuperSkuMiddleware_MiddlewareSlot
  } from '@thd-olt-component-middleware/pip';






  
  import { PIPRedirector }
    from "@thd-nucleus/app-render";
  
  export { PIPRedirector };

  
  import { ProductMetadata }
    from "@thd-olt-component-react/metadata";
  
  export { ProductMetadata };

  
  import { Breadcrumbs }
    from "@thd-olt-component-react/breadcrumbs";
  
  export { Breadcrumbs };

  
  import { ProductInfoBar }
    from "@thd-olt-component-react/product-info-bar";
  
  export { ProductInfoBar };

  
  import { ConnectedTranslatorWidget }
    from "@thd-olt-component-react/translator_widget";
  
  export { ConnectedTranslatorWidget };

  
  import { DynamicRecsWrapperPip }
    from "@thd-olt-component-react/thd-recs-containers";
  
  export { DynamicRecsWrapperPip };

  
  import { Discontinued }
    from "@thd-olt-component-react/discontinued";
  
  export { Discontinued };

  
  import { MediaGalleryHorizontalWithHotspots }
    from "@thd-olt-component-react/media-gallery";
  
  export { MediaGalleryHorizontalWithHotspots };

  
  import { RoomVo }
    from "@thd-olt-component-react/augmented-reality";
  
  export { RoomVo };

  
  import { ProductPageEventCountdownTimer }
    from "@thd-olt-component-react/event-countdown-timer";
  
  export { ProductPageEventCountdownTimer };

  
  import { PIPProductDetails }
    from "@thd-olt-component-react/product-details";
  
  export { PIPProductDetails };

  
  import { PromotionUrgencyMessaging }
    from "@thd-olt-component-react/promotion";
  
  export { PromotionUrgencyMessaging };

  
  import { PIPPriceClearanceWrapper }
    from "@thd-olt-component-react/price";
  
  export { PIPPriceClearanceWrapper };

  
  import { Promotion }
    from "@thd-olt-component-react/promotion";
  
  export { Promotion };

  
  import { DisclaimerMessage }
    from "@thd-olt-component-react/disclaimer-message";
  
  export { DisclaimerMessage };

  
  import { ConsumerCardMessaging }
    from "@thd-olt-component-react/consumer-card-messaging";
  
  export { ConsumerCardMessaging };

  
  import { PromotionProductsAnchor }
    from "@thd-olt-component-react/promotion-products";
  
  export { PromotionProductsAnchor };

  
  import { PIPSalientPoints }
    from "@thd-olt-component-react/salient-points";
  
  export { PIPSalientPoints };

  
  import { AisleBay }
    from "@thd-olt-component-react/aisle-bay";
  
  export { AisleBay };

  
  import { SuperSku }
    from "@thd-olt-component-react/super-sku";
  
  export { SuperSku };

  
  import { ConfiguratorAndPipFlipLayout }
    from "@thd-olt-component-react/product-configurator";
  
  export { ConfiguratorAndPipFlipLayout };

  
  import { GlobalCustomConfigurator }
    from "@thd-olt-component-react/global-custom-configurator";
  
  export { GlobalCustomConfigurator };

  
  import { OrderSample }
    from "@thd-olt-component-react/order-sample";
  
  export { OrderSample };

  
  import { BuyboxWithPIPCalculator }
    from "@thd-olt-component-react/buybox";
  
  export { BuyboxWithPIPCalculator };

  
  import { ReturnsMessaging }
    from "@thd-olt-component-react/returns-messaging";
  
  export { ReturnsMessaging };

  
  import { CalcLink }
    from "@thd-olt-component-react/moving-calculator";
  
  export { CalcLink };

  
  import { BundlePmvFbtLayoutGmAndHdh }
    from "@thd-olt-component-react/bundle-mini";
  
  export { BundlePmvFbtLayoutGmAndHdh };

  
  import { ProductOverviewAccordionTitle }
    from "@thd-olt-component-react/product-overview";
  
  export { ProductOverviewAccordionTitle };

  
  import { SpecificationsAccordionTitle }
    from "@thd-olt-component-react/specifications";
  
  export { SpecificationsAccordionTitle };

  
  import { QuestionsAndAnswersAccordionTitle }
    from "@thd-olt-component-react/questions-and-answers";
  
  export { QuestionsAndAnswersAccordionTitle };

  
  import { RatingsAndReviewsAccordionTitle }
    from "@thd-olt-component-react/ratings-and-reviews";
  
  export { RatingsAndReviewsAccordionTitle };

  
  import { BazaarVoiceCarousel }
    from "@thd-olt-component-react/social-media-container";
  
  export { BazaarVoiceCarousel };

  
  import { RoomVoInspire }
    from "@thd-olt-component-react/augmented-reality";
  
  export { RoomVoInspire };

  
  import { BathRenovation }
    from "@thd-olt-component-react/augmented-reality";
  
  export { BathRenovation };

  
  import { SponsoredPipBanner }
    from "@thd-olt-component-react/sponsored-content";
  
  export { SponsoredPipBanner };

  
  import { EducationalSummary }
    from "@thd-olt-component-react/educational-summary";
  
  export { EducationalSummary };

  
  import { RetailMediaCarouselFusionPIP }
    from "@thd-olt-component-react/retail-media-pla-sponsored-placements";
  
  export { RetailMediaCarouselFusionPIP };

  
  import { FeatureBasedRecommendationsImporterVite }
    from "@thd-olt-component-react/feature-based-recommendations";
  
  export { FeatureBasedRecommendationsImporterVite };

  
  import { RecentlyViewedWrapper }
    from "@thd-olt-component-react/thd-recs-containers";
  
  export { RecentlyViewedWrapper };

  
  import { RelatedSearch }
    from "@thd-olt-component-react/related-search";
  
  export { RelatedSearch };

  
  import { RelatedProducts }
    from "@thd-olt-component-react/related-search";
  
  export { RelatedProducts };

  
  import { PopularVariations }
    from "@thd-olt-component-react/related-search";
  
  export { PopularVariations };

  
  import { EmtLinks }
    from "@thd-olt-component-react/emt-links";
  
  export { EmtLinks };






import { BotPrompt as BotPromptSSR } from '@thd-olt-component-react/magic-apron?clientSideRemove';

import { ProductOverviewAccordionTitle as ProductOverviewAccordionTitleSSR } from '@thd-olt-component-react/product-overview?clientSideRemove';

import { SpecificationsAccordionTitle as SpecificationsAccordionTitleSSR } from '@thd-olt-component-react/specifications?clientSideRemove';

import { QuestionsAndAnswersAccordionTitle as QuestionsAndAnswersAccordionTitleSSR } from '@thd-olt-component-react/questions-and-answers?clientSideRemove';

import { RatingsAndReviewsAccordionTitle as RatingsAndReviewsAccordionTitleSSR } from '@thd-olt-component-react/ratings-and-reviews?clientSideRemove';

import { ProductOverviewAccordionBody as ProductOverviewAccordionBodySSR } from '@thd-olt-component-react/product-overview?clientSideRemove';

import { SpecificationsAccordionBody as SpecificationsAccordionBodySSR } from '@thd-olt-component-react/specifications?clientSideRemove';

import { QuestionsAndAnswersAccordionBody as QuestionsAndAnswersAccordionBodySSR } from '@thd-olt-component-react/questions-and-answers?clientSideRemove';

import { RatingsAndReviewsAccordionBody as RatingsAndReviewsAccordionBodySSR } from '@thd-olt-component-react/ratings-and-reviews?clientSideRemove';



  
    
      
      
        const SlotA1 = withLayout(
          [
            
              
              PIPRedirector,
            
          ],
          
        );
      
      
    
  

  
    
      
      
        const SlotA2 = withLayout(
          [
            
              
              ProductMetadata,
            
          ],
          
        );
      
      
    
  

  
    
      
      
        const SlotB1 = withLayout(
          [
            
              
              Breadcrumbs,
            
          ],
          
        );
      
      
    
  

  
    
      
      
        const SlotC1 = withLayout(
          [
            
              
              ProductInfoBar,
            
          ],
          
        );
      
      
    
  

  
    
      
      
        const SlotC2 = withLayout(
          [
            
              
              ConnectedTranslatorWidget,
            
          ],
          
        );
      
      
    
  

  
    
      
      
        const SlotD1 = withLayout(
          [
            
              
              DynamicRecsWrapperPip,
            
          ],
          
        );
      
      
    
  

  
    
      
      
        const SlotD2 = withLayout(
          [
            
              
              Discontinued,
            
          ],
          
        );
      
      
    
  

  
    
      
      
        const SlotE1 = withLayout(
          [
            
              
              MediaGalleryHorizontalWithHotspots,
            
          ],
          
        );
      
      
    
  

  
    
      
      
        const SlotE2 = withLayout(
          [
            
              
              RoomVo,
            
          ],
          
        );
      
      
    
  

  
    
      
      
        const SlotF1 = withLayout(
          [
            
              
              ProductPageEventCountdownTimer,
            
          ],
          
        );
      
      
    
  

  
    
      
      
        const SlotF2 = withLayout(
          [
            
              
              PIPProductDetails,
            
          ],
          
        );
      
      
    
  

  
    
      
      
        const SlotF3 = withLayout(
          [
            
              
              PromotionUrgencyMessaging,
            
          ],
          
        );
      
      
    
  

  
    
      
      
        const SlotF4 = withLayout(
          [
            
              
              PIPPriceClearanceWrapper,
            
          ],
          
        );
      
      
    
  

  
    
      
      
        const SlotF5 = withLayout(
          [
            
              
              Promotion,
            
          ],
          
        );
      
      
    
  

  
    
      
      
        const SlotF6 = withLayout(
          [
            
              
              DisclaimerMessage,
            
          ],
          
        );
      
      
    
  

  
    
      
      
        const PLCCAbove = withLayout(
          [
            
              
              ConsumerCardMessaging,
            
          ],
          
        );
      
      
    
  

  
    
      
      
        const SlotF8 = withLayout(
          [
            
              
              PromotionProductsAnchor,
            
          ],
          
        );
      
      
    
  

  
    
      
      
        const SlotF9 = withLayout(
          [
            
              
              PIPSalientPoints,
            
          ],
          
        );
      
      
    
  

  
    
      
      
        const SlotF10 = withLayout(
          [
            
              
              AisleBay,
            
          ],
          
        );
      
      
    
  

  
    
      
        let SuperSkuMiddleware_MiddlewareSlot_SlotF11 = SuperSkuMiddleware_MiddlewareSlot;
        
      
      
        const SlotF11 = withLayout(
          [
            
              
              SuperSku,
            
          ],
          
            SuperSkuMiddleware_MiddlewareSlot_SlotF11
          
        );
      
      
    
  

  
    
      
      
        const SlotF12 = withLayout(
          [
            
              
              ConfiguratorAndPipFlipLayout,
            
          ],
          
        );
      
      
    
  

  
    
      
      
        const SlotF13 = withLayout(
          [
            
              
              GlobalCustomConfigurator,
            
          ],
          
        );
      
      
    
  

  
    
      
      
        const SlotF14 = withLayout(
          [
            
              
              OrderSample,
            
          ],
          
        );
      
      
    
  

  
    
      
      
        const SlotF15 = withLayout(
          [
            
              
              BuyboxWithPIPCalculator,
            
          ],
          
        );
      
      
    
  

  
    
      
      
        const SlotF16 = withLayout(
          [
            
              
              ReturnsMessaging,
            
          ],
          
        );
      
      
    
  

  
    
      
      
        const SlotF17 = withLayout(
          [
            
              
              CalcLink,
            
          ],
          
        );
      
      
    
  

  
    
      
      
        const SlotF18 = withLayout(
          [
            
              
              GlobalCustomConfigurator,
            
          ],
          
        );
      
      
    
  

  
    
      
      
        const SlotG1 = withLayout(
          [
            
              
              DynamicRecsWrapperPip,
            
          ],
          
        );
      
      
    
  

  
    
      
      
        const SlotG2 = withLayout(
          [
            
              
              BundlePmvFbtLayoutGmAndHdh,
            
          ],
          
        );
      
      
    
  

  
    
      
      
        const SlotG3 = withLayout(
          [
            
              
              DynamicRecsWrapperPip,
            
          ],
          
        );
      
      
    
  

  
    
      
      
        const SlotG4 = withLayout(
          [
            
              
              DynamicRecsWrapperPip,
            
          ],
          
        );
      
      
    
  

  

  

  

  
    
      
      
        const SlotG8 = withLayout(
          [
            
              
              BazaarVoiceCarousel,
            
          ],
          
        );
      
      
    
  

  
    
      
      
        const SlotG9 = withLayout(
          [
            
              
              RoomVoInspire,
            
          ],
          
        );
      
      
    
  

  
    
      
      
        const SlotG10 = withLayout(
          [
            
              
              BathRenovation,
            
          ],
          
        );
      
      
    
  

  
    
      
      
        const SlotG11 = withLayout(
          [
            
              
              DynamicRecsWrapperPip,
            
          ],
          
        );
      
      
    
  

  
    
      
      
        const SlotG12 = withLayout(
          [
            
              
              DynamicRecsWrapperPip,
            
          ],
          
        );
      
      
    
  

  
    
      
      
        const SlotG13 = withLayout(
          [
            
              
              SponsoredPipBanner,
            
          ],
          
        );
      
      
    
  

  
    
      
      
        const SlotG14 = withLayout(
          [
            
              
              EducationalSummary,
            
          ],
          
        );
      
      
    
  

  
    
      
      
        const SlotG15 = withLayout(
          [
            
              
              DynamicRecsWrapperPip,
            
          ],
          
        );
      
      
    
  

  
    
      
      
        const SlotG16 = withLayout(
          [
            
              
              DynamicRecsWrapperPip,
            
          ],
          
        );
      
      
    
  

  
    
      
      
        const SlotG17 = withLayout(
          [
            
              
              DynamicRecsWrapperPip,
            
          ],
          
        );
      
      
    
  

  
    
      
      
        const SlotG18 = withLayout(
          [
            
              
              DynamicRecsWrapperPip,
            
          ],
          
        );
      
      
    
  

  
    
      
      
        const SlotG19 = withLayout(
          [
            
              
              DynamicRecsWrapperPip,
            
          ],
          
        );
      
      
    
  

  
    
      
      
        const SlotG20 = withLayout(
          [
            
              
              DynamicRecsWrapperPip,
            
          ],
          
        );
      
      
    
  

  
    
      
      
        const SlotG21 = withLayout(
          [
            
              
              RetailMediaCarouselFusionPIP,
            
          ],
          
        );
      
      
    
  

  
    
      
      
        const SlotG22 = withLayout(
          [
            
              
              FeatureBasedRecommendationsImporterVite,
            
          ],
          
        );
      
      
    
  

  
    
      
      
        const SlotG23 = withLayout(
          [
            
              
              DynamicRecsWrapperPip,
            
          ],
          
        );
      
      
    
  

  
    
      
      
        const SlotG24 = withLayout(
          [
            
              
              RecentlyViewedWrapper,
            
          ],
          
        );
      
      
    
  

  
    
      
      
        const SlotG25 = withLayout(
          [
            
              
              RelatedSearch,
            
          ],
          
        );
      
      
    
  

  
    
      
      
        const SlotG26 = withLayout(
          [
            
              
              RelatedProducts,
            
          ],
          
        );
      
      
    
  

  
    
      
      
        const SlotG27 = withLayout(
          [
            
              
              PopularVariations,
            
          ],
          
        );
      
      
    
  

  
    
      
      
        const SlotG28 = withLayout(
          [
            
              
              EmtLinks,
            
          ],
          
        );
      
      
    
  



const ssr = typeof window === 'undefined';


  
  

  
  

  
  

  
  

  
  

  
  

  
  

  
  

  
  

  
  

  
  

  
  

  
  

  
  

  
  

  
  

  
  

  
  

  
  

  
  

  
  

  
  

  
  

  
  

  
  

  
  

  
  

  
  

  
  

  
  

  
  

  
  
    


    
      
        const SlotG5Index0DataModel = ssr
        ? BotPromptSSR
        : {};

      
    
  

  
  
    
      
      
        
          const SlotG6KTitle1Index0DataModelK0 = ssr
          ? ProductOverviewAccordionTitleSSR
          : {};
        
        
        
          const SlotG6KBody1Index0DataModelBodyK0 = ssr
          ? ProductOverviewAccordionBodySSR
          : {};
        
      
        
          const SlotG6KTitle2Index1DataModelK0 = ssr
          ? SpecificationsAccordionTitleSSR
          : {};
        
        
        
          const SlotG6KBody2Index1DataModelBodyK0 = ssr
          ? SpecificationsAccordionBodySSR
          : {};
        
      
        
          const SlotG6KTitle3Index2DataModelK0 = ssr
          ? QuestionsAndAnswersAccordionTitleSSR
          : {};
        
        
        
          const SlotG6KBody3Index2DataModelBodyK0 = ssr
          ? QuestionsAndAnswersAccordionBodySSR
          : {};
        
      
        
          const SlotG6KTitle4Index3DataModelK0 = ssr
          ? RatingsAndReviewsAccordionTitleSSR
          : {};
        
        
        
          const SlotG6KBody4Index3DataModelBodyK0 = ssr
          ? RatingsAndReviewsAccordionBodySSR
          : {};
        
      
    


    
  

  
  
    


    
      
        const SlotG7Index0DataModel = ssr
        ? BotPromptSSR
        : {};

      
    
  

  
  

  
  

  
  

  
  

  
  

  
  

  
  

  
  

  
  

  
  

  
  

  
  

  
  

  
  

  
  

  
  

  
  

  
  

  
  

  
  

  
  



export {
  
  
    
      SlotA1,
    
  
    
      SlotA2,
    
  
    
      SlotB1,
    
  
    
      SlotC1,
    
  
    
      SlotC2,
    
  
    
      SlotD1,
    
  
    
      SlotD2,
    
  
    
      SlotE1,
    
  
    
      SlotE2,
    
  
    
      SlotF1,
    
  
    
      SlotF2,
    
  
    
      SlotF3,
    
  
    
      SlotF4,
    
  
    
      SlotF5,
    
  
    
      SlotF6,
    
  
    
      PLCCAbove,
    
  
    
      SlotF8,
    
  
    
      SlotF9,
    
  
    
      SlotF10,
    
  
    
      SlotF11,
    
  
    
      SlotF12,
    
  
    
      SlotF13,
    
  
    
      SlotF14,
    
  
    
      SlotF15,
    
  
    
      SlotF16,
    
  
    
      SlotF17,
    
  
    
      SlotF18,
    
  
    
      SlotG1,
    
  
    
      SlotG2,
    
  
    
      SlotG3,
    
  
    
      SlotG4,
    
  
    
  
    
  
    
  
    
      SlotG8,
    
  
    
      SlotG9,
    
  
    
      SlotG10,
    
  
    
      SlotG11,
    
  
    
      SlotG12,
    
  
    
      SlotG13,
    
  
    
      SlotG14,
    
  
    
      SlotG15,
    
  
    
      SlotG16,
    
  
    
      SlotG17,
    
  
    
      SlotG18,
    
  
    
      SlotG19,
    
  
    
      SlotG20,
    
  
    
      SlotG21,
    
  
    
      SlotG22,
    
  
    
      SlotG23,
    
  
    
      SlotG24,
    
  
    
      SlotG25,
    
  
    
      SlotG26,
    
  
    
      SlotG27,
    
  
    
      SlotG28,
    
  

  
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
      
      

      
        
          SlotG5Index0DataModel,
        
      
    
  
    
      
      
        
          
          
            SlotG6KTitle1Index0DataModelK0,
          
          
          
            SlotG6KBody1Index0DataModelBodyK0,
          
        
          
          
            SlotG6KTitle2Index1DataModelK0,
          
          
          
            SlotG6KBody2Index1DataModelBodyK0,
          
        
          
          
            SlotG6KTitle3Index2DataModelK0,
          
          
          
            SlotG6KBody3Index2DataModelBodyK0,
          
        
          
          
            SlotG6KTitle4Index3DataModelK0,
          
          
          
            SlotG6KBody4Index3DataModelBodyK0,
          
        
      

      
    
  
    
      
      

      
        
          SlotG7Index0DataModel,
        
      
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  

};